/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class WebHmiManagementService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** Web HMI 비밀번호 조회 */
    getWebHmiPassword = async (params) => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/security/ems/web/hmi/passwords'), params);
        return data;
    };
}
export { WebHmiManagementService };
